import settings from "../../../constants/settings";
import useFetchAndTrace from "../fetchWithTrace";
import { useState } from "react";

export default function useUpdateContainerQuantity(
  onSuccess: () => void,
  onError: (detail: string) => void,
) {
  const fetchAndTrace = useFetchAndTrace();
  const [loading, setLoading] = useState(false);
  const errorHandler = () => {
    setLoading(false);
    onError("Failed to update container quantity");
  };

  const updateContainerQuantityHandler = async (response: Response) => {
    setLoading(false);
    if (response.ok) {
      onSuccess();
    } else if (response.status == 400) {
      const { detail } = (await response.json()) as { detail: string };
      onError(detail);
    } else {
      throw Error("Failed to update container quantity.");
    }
  };

  const updateContainerQuantity = (
    containerBarcode: string,
    quantity: number,
  ) => {
    setLoading(true);
    void fetchAndTrace(
      `${settings.api_url}/inventory/containers/quantity`,
      updateContainerQuantityHandler,
      errorHandler,
      {
        body: JSON.stringify({
          quantity: quantity,
          flashpcb_container_barcode: containerBarcode,
        }),
        method: "PUT",
      },
    );
  };
  return {
    updateContainerQuantity,
    loading,
  };
}
